import { render, staticRenderFns } from "./SelfSignUp.vue?vue&type=template&id=263a58d8&scoped=true&lang=pug"
import script from "./SelfSignUp.vue?vue&type=script&lang=js"
export * from "./SelfSignUp.vue?vue&type=script&lang=js"
import style0 from "./SelfSignUp.vue?vue&type=style&index=0&id=263a58d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263a58d8",
  null
  
)

export default component.exports